// extracted by mini-css-extract-plugin
export var label = "_j4-2";
export var slideContainer = "_j4-0";
export var slider = "_j4-1";